import { render, staticRenderFns } from "./ProductDiscountSettingPopupIframe.vue?vue&type=template&id=e0ce02e8&"
import script from "./ProductDiscountSettingPopupIframe.vue?vue&type=script&lang=ts&"
export * from "./ProductDiscountSettingPopupIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports